import React, { useState, useRef } from 'react';
import { MdDisabledByDefault } from "react-icons/md";
import { FcOk } from "react-icons/fc";
import { FaCamera } from 'react-icons/fa';
import { uploadimagesReflex, reflexcreate, getReflex } from '../../api/api';
import { useNavigate, useLocation } from 'react-router-dom';
import Webcam from 'react-webcam';
import Modal from 'react-modal';
import { useMediaQuery } from 'react-responsive';
import atos from '../../assets/atos-logo.svg';
import '../../styles/Buttons.css';
import '../../styles/Texts.css';
import '../../styles/Alinhamento.css';
import '../../styles/Imagens.css';
import "react-widgets/styles.css";

function CriarReflex() {
    const navigate = useNavigate();
    const location = useLocation();
    const user = location.state?.user || localStorage.getItem('user');
    const isBigScreen = useMediaQuery({ query: '(min-width: 481px)' });
    const [index, setindex] = useState();
    const [isChecked, setIsChecked] = useState(false);
    const [equipamento, setEquipamento] = useState({
        hostname:  '',
        numero_serie: '',
        fan: '',
        modelo: '',
        oficina_zona_taller: '',
        pilar: '',
        apellidos_titular_nombre_titular: '',
        grupo: '',
        windows_build: '',
        estado: '',
        utilizacion: '',
        tipo_ci_tipo_puesto: '',
        direccion_ip: '',
        na: '',
        centro_produccion:  '',
        comentarios: '',
        fecha_creacion: '',
        verificacao_etiqueta: '',
        respostas_psav3: '',
        tipo_uso: '',
        numero_inventario: '',
        idade_meses: '',
        encontrado: false,
        alterado_em: '',
    });
    const [isCameraModalOpen, setIsCameraModalOpen] = useState(false);
    const [isWebcamModalOpen, setIsWebcamModalOpen] = useState(false);
    const [selectedCamera, setSelectedCamera] = useState();
    const [imageUrls, setImageUrls] = useState([]);
    const webcamRef = useRef(null);

    const videoConstraints = { facingMode: { exact: "environment" } };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEquipamento(prevState => ({
            ...prevState,
            [name]: value
        }));        
    };

    const handleCheckboxChange = () => {
        setIsChecked(prev => !prev);
        setEquipamento(prevState => ({
            ...prevState,
            encontrado: !prevState.encontrado
        }));
    };

    const fetchUsers = async (updatedEquipamento) => {
        updatedEquipamento.alterado_em = new Date().toISOString();
        const data = await reflexcreate(user, updatedEquipamento);
        setindex(data.id)        
        alert('Novo equipamento criado com sucesso.');
        const response = await getReflex();
        const equipamentoR = response.map((r) => ({
            ...r.fields,
            pk: r.pk
        }));    
        localStorage.setItem('equipamentosR', JSON.stringify(equipamentoR));
        navigate('/reflex', { state: { user } })
        
    };

    const handleSave = async () => {
        await fetchUsers(equipamento);        
    };

    const handleOpenCameraModal = () => {
        if(index != null){
            setIsCameraModalOpen(true);
        }else{
            alert('Salve o equipamento antes de prosseguir.');  
    }};

    const handleOpenWebcamModal = (cameraIndex) => {
        setSelectedCamera(cameraIndex);
        setIsCameraModalOpen(false);
        setIsWebcamModalOpen(true);
    };

    const handleTakePhoto = async (slot) => {
        setIsWebcamModalOpen(false);
        const imageSrc = webcamRef.current.getScreenshot();
        const filename = `${equipamento.nome}_${slot}.jpg`;
        await uploadimagesReflex(index, imageSrc, slot, filename);
        setImageUrls([...imageUrls, imageSrc]);
        setIsCameraModalOpen(true);
    };

    const handleTakePhotoCancel = () => {
        setIsWebcamModalOpen(false);
        setIsCameraModalOpen(true);
    };

    const handleOpenWebcamModalCancel = () => {
        setIsCameraModalOpen(false);
        setIsWebcamModalOpen(false);
    };

    return (
        <>
            <main>
                <p></p>
                <div className='icon-container'>
                    <div className='checkbox-container' onClick={handleCheckboxChange}>
                        {isChecked ? <FcOk size={50} /> : <MdDisabledByDefault size={50} />}
                    </div>
                </div>

                <div className='conteudo-principal'>
                    <div className='equipamento-barra-alinhamento'>
                        <div className='equipamento-conteudo'>
                            {Object.entries(equipamento).map(([key, value]) => {
                                if (key === 'encontrado') return null;
                                let inputElement;
                                if (key === 'alterado_em' || key === 'fecha_creacion') {
                                    inputElement = (<input type='datetime-local' name={key} value={value} onChange={handleInputChange} />);
                                } else {
                                    inputElement = (<input type='text' name={key} value={value} onChange={handleInputChange} />);
                                }
                                return (
                                    <div className='equipamento-item' key={key}>
                                        <label>{key.charAt(0).toUpperCase() + key.slice(1)}:</label>
                                        {inputElement}
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <button className='button-editar-perfil-usuario Atos-logo' title="Salvar Alteração" onClick={handleSave}>Salvar</button>
                    <button className='button-editar-perfil-usuario Atos-logo' title="Voltar" onClick={() => navigate('/reflex', { state: { user } })}>Voltar</button>
                    <footer>
                        <img src={atos} className='footer-alinhamento-fixed Atos-logo' alt='logo atos' />
                    </footer>
                </div>

                <Modal
                    isOpen={isCameraModalOpen}
                    onRequestClose={() => setIsCameraModalOpen(false)}
                    contentLabel="Select Camera"
                    className='conteudo-principal'
                    overlayClassName="modal-overlay"
                    style={{
                        content: {
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            maxHeight: '100vh',
                            margin: 'auto',
                            padding: '20px',
                        },
                    }}
                >
                    <div className='camera-icons-container'>
                        {imageUrls.map((img, index) => (
                            <img
                                key={index}
                                src={img}
                                alt={`Imagem carregada ${index + 1}`}
                                style={{ width: 170, height: 170 }}
                                onClick={() => handleOpenWebcamModal(index)}
                            />
                        ))}
                    </div>
                    <div className='camera-icons-container'>
                        <button
                            className='button-editar-perfil-usuario Atos-logo'
                            title="Cancelar"
                            onClick={handleOpenWebcamModalCancel}
                        >
                            Cancelar
                        </button>
                    </div>
                </Modal>

            </main>
            <Modal
                isOpen={isWebcamModalOpen}
                onRequestClose={() => setIsWebcamModalOpen(false)}
                contentLabel="Capture Photo"
                className='camera-icons-container'
                overlayClassName="overlay"
            >
                <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                    videoConstraints={videoConstraints}
                    style={{ width: 450, height: 450 }}
                />
                <div className="button-container">
                    <button className='button-editar-perfil-usuario Atos-logo' title="Tirar foto" onClick={() => handleTakePhoto(selectedCamera)}>Salvar Foto</button>
                    <button className='button-editar-perfil-usuario Atos-logo' title="Cancelar" onClick={handleTakePhotoCancel}>Cancelar</button>
                </div>
            </Modal>
        </>
    );
}

export default CriarReflex;
